import { render, staticRenderFns } from "./EnforcementForm.vue?vue&type=template&id=ac2b2138"
import script from "./EnforcementForm.vue?vue&type=script&lang=js"
export * from "./EnforcementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports